var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 6.4l-1.4-1.4-5.6 5.6-5.6-5.6-1.4 1.4 5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"}));
}

Close.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
